import { useTranslation } from "react-i18next";

import { Group, Loader, Text } from "@mantine/core";

import { simpleResultErrorMessage } from "@prostocheck/i18n";
import { Button, Card } from "@prostocheck/ui";

import { IAsyncStateProps } from "./async-state.models";

/**
 * Every screen reads from ДПС over a signed request, so every screen can be
 * waiting or broken. Rendered instead of the content, never alongside stale
 * numbers — a half-loaded total is worse than a spinner.
 */
export const AsyncState = ({
  isLoading,
  errorResult,
  onRetry,
}: IAsyncStateProps) => {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <Card>
        <Group gap="sm" role="status">
          <Loader size="sm" />
          <Text size="sm" c="dimmed">
            {t("async.loading")}
          </Text>
        </Group>
      </Card>
    );
  }

  return (
    <Card>
      <Text size="sm" fw={500}>
        {errorResult
          ? simpleResultErrorMessage({ result: errorResult, t })
          : t("errors.common.unknown")}
      </Text>
      <Text size="sm" c="dimmed" mt={6}>
        {t("async.errorHint")}
      </Text>
      <Button variant="secondary" className="mt-4" onClick={onRetry}>
        {t("async.retry")}
      </Button>
    </Card>
  );
};
